import type { Router } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { waitForAuthBootstrap } from '@/utils/liff'

export function registerAuthGuard(router: Router) {
  router.beforeEach(async (to, from, next) => {
    // Wait for the startup LIFF init + server-side login validation to
    // settle before trusting auth.isAuthenticated — otherwise the router's
    // initial navigation (which fires as soon as app.use(router) runs) would
    // always see an empty token and bounce to /login before validation had
    // a chance to complete.
    if (to.meta.requiresAuth) {
      await waitForAuthBootstrap()
    }

    const auth = useAuthStore()

    // If route requires auth and user not yet logged in
    if (to.meta.requiresAuth && !auth.isAuthenticated) {
      next('/login')
    } else {
      next()
    }
  })
}
